import React from 'react';
import { CheckCircle2, Clock3, Download, Film, Play } from 'lucide-react';

const statusLabel = (project) => {
  if (project.status === 'ready') return 'Ready';
  if (['edit_queued', 'editing', 'quality_check'].includes(project.status)) return 'Creating Reel';
  if (project.status === 'failed') return 'Needs attention';
  if (project.status === 'draft' || project.status === 'reference_uploaded') return 'Add reference';
  const remaining = Math.max(0, Number(project.clipsRequired || 0) - Number(project.clipsComplete || 0));
  return `Film ${remaining} ${remaining === 1 ? 'clip' : 'clips'}`;
};

export default function ReelProjectCard({ project, onContinue }) {
  const ready = project.status === 'ready';
  const date = new Date(project.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return (
    <article className="rounded-2xl border border-gray-800 bg-gray-900 p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="truncate text-lg font-semibold text-white">{project.title || 'New Reel'}</h3>
          <p className="mt-1 text-xs text-gray-500">{date}</p>
        </div>
        {ready ? <CheckCircle2 className="shrink-0 text-green-400" size={22} /> : <Film className="shrink-0 text-purple-300" size={22} />}
      </div>
      <p className={`mt-4 font-semibold ${ready ? 'text-green-300' : 'text-purple-200'}`}>{statusLabel(project)}</p>
      {project.clipsRequired > 0 && (
        <p className="mt-1 text-sm text-gray-400">{project.clipsComplete} of {project.clipsRequired} clips complete</p>
      )}
      <div className="mt-5 flex flex-wrap gap-2">
        <button onClick={() => onContinue(project)} className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl bg-purple-600 px-4 py-2 text-sm font-semibold hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-300">
          {ready ? <Play size={16} /> : <Clock3 size={16} />} {ready ? 'Preview' : 'Continue'}
        </button>
        {ready && (
          <a href={project.finishedVideoUrl || '/demo-reel.mp4'} download className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-gray-700 px-4 py-2 text-sm font-semibold text-gray-200 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-300">
            <Download size={16} /> Download
          </a>
        )}
      </div>
    </article>
  );
}

